<template>
    <v-dialog v-model="dialog" width="800">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>{{ item.raw.displayName }}</v-card-title>
            <v-card-text>
                <v-text-field v-model="editContext.loginId" label="로그인 아이디"></v-text-field>
                <v-text-field v-model="editContext.displayName" label="Display Name"></v-text-field>
                <v-text-field v-model="editContext.countryCode" label="국가"></v-text-field>
                <v-text-field v-model="editContext.languageCode" label="언어"></v-text-field>
                <v-select
                        v-model="editContext.permissionGroupCode"
                        :items="systemGroupCodeOptions"
                        item-text="code"
                        item-value="code"
                        label="권한그룹">
                </v-select>
            </v-card-text>
            <v-card-actions class="justify-space-between">
                <v-btn text color="primary" @click="onClickReset">Reset</v-btn>
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="onClose">Cancel</v-btn>
                <v-btn text color="primary" @click="onSave">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
    import {PATH} from "@/constants";

    export default {
        name: "SystemUserEditFormModal",
        mixins: [TotalCodeOptions],
        props: {
            item: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                dialog: false,
                editContext: {},
            };
        },
        watch: {
            item() {
                this.$cloneReactiveNew(this.item.raw, this.editContext);
            },
        },
        created() {
            this.loadSystemGroupCodeOptions();
            this.$cloneReactiveNew(this.item.raw, this.editContext);
        },
        methods: {
            onClickReset() {
                this.$cloneReactiveNew(this.item.raw, this.editContext);
            },

            async onSave() {
                this.editContext.register = null;
                this.$requestWithOverlay(PATH.ADMIN_USER.UPDATE)
                    .setObject(this.editContext)
                    .enqueue()
                    .then(() => {
                        this.$cloneReactiveNew(this.editContext, this.item.raw);
                        this.onClose();
                    });
                this.editContext.register = this.item.raw.register;
            },

            onClose() {
                this.dialog = false;
            },
        },
    }
</script>

<style scoped>

</style>
